export type PrintStrategy = 'server' | 'zpl';
export const DEFAULT_PRINT_STRATEGY: PrintStrategy = 'server';

export const getDefaultZebraDevice = (): Promise<ZebraDevice> =>
  new Promise<ZebraDevice>((resolve, reject) => {
    const sdk = (window as any).BrowserPrint;
    if (!sdk) {
      reject(
        new Error('Zebra Browser Print SDK não está disponível. Verifique se o script foi carregado corretamente.')
      );
      return;
    }
    sdk.getDefaultDevice(
      'printer',
      (device: ZebraDevice) => {
        console.log('device', device);
        if (!device || !device.name) {
          reject(new Error('Nenhuma impressora Zebra encontrada. Verifique se a impressora está conectada.'));
          return;
        }
        resolve(device);
      },
      (error: string) => {
        reject(new Error(error || 'Falha ao conectar com o Zebra Browser Print'));
      }
    );
  });

export const printZpl = (device: ZebraDevice, zpl: string): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    device.send(
      zpl,
      () => resolve(),
      (error: string) => {
        reject(new Error(error || 'Falha ao enviar dados para a impressora Zebra'));
      }
    );
  });

interface PrintTagsParams {
  pcId?: string;
  order: string;
  quantity: number;
  productType: string;
  printStrategy: PrintStrategy;
  printMutation: any;
  printTagSSEMutation: any;
  distributionCenterId?: string;
  lastCode?: number;
  printLocally?: (order: string, tagCode: string) => Promise<void>;
}

export const printTags = ({
  pcId,
  order,
  quantity,
  productType,
  printStrategy,
  printMutation,
  printTagSSEMutation,
  distributionCenterId,
  lastCode,
  printLocally,
}: PrintTagsParams) => {
  repeat(quantity)((index: number) => {
    const tagCode = getTagCode(order, productType, lastCode ? lastCode + index : index);
    if (printStrategy === 'zpl') {
      if (printLocally) {
        printLocally(order, tagCode);
      } else {
        printTagSSEMutation({
          variables: {
            input: { order, tagCode, pcId: Number(pcId), distributionCenterId },
          },
        });
      }
    } else {
      printMutation({
        variables: {
          input: {
            pcId,
            order,
            tagCode,
            productType,
            quantity: 1,
            useGoogle: false,
          },
        },
      });
    }
  });
};

const repeat = (total: number) => (func: any) => {
  const iter = (i: number) => {
    if (i === total) return;
    func(i);
    iter(i + 1);
  };
  return iter(0);
};

export const getTagCode = (order: string, productType: string, index: number): string => {
  const bagIndexCode = (index + 1).toString().padStart(3, '0');
  const productTypeInitial = getProductTypeInitial(productType);

  return `${order}-${productTypeInitial}-${bagIndexCode}`;
};

const getProductTypeInitial = (productType: string): string => productType.slice(0, 1).toUpperCase();
